/**
 * ISK currency formatting utilities.
 * Icelandic convention: dots as thousand separators, no decimals.
 */

/** Strip all non-digit characters, return raw integer string */
export function sanitizeISK(value) {
  return String(value).replace(/[^\d]/g, '');
}

/** Format a raw number string with Icelandic thousand separators (dots) */
export function formatISK(value) {
  const raw = sanitizeISK(value);
  if (!raw) return '';
  return Number(raw).toLocaleString('de-DE'); // de-DE uses dots as thousand separators
}

/** Parse formatted ISK string to integer */
export function parseISK(value) {
  const raw = sanitizeISK(value);
  return raw ? parseInt(raw, 10) : 0;
}
